import { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import StyledWrapper from "./style";
import { TModalProps } from "./Modal.type";
import { useModal } from "../../../hooks";

/**
 * paginationItems
 * @param {Element} children Elements to be displayed inside component. Can be passed as prop or inside component tags
 * @param {Boolean} show Boolean value to open modal can be passed useState variable which is switched by a click Example onClick={() => { setToggleModal(!toggleModal) }}
 * @param {String} modalTitle Title for Modal
 * @param {String} titleStyle Styles for Modal Tittle
 * @param {String} urlTittle Title for Modal
 * @param {String} modalContainerStyle Styles for Modal Container
 */

export default function Modal({
  children,
  show,
  modalTitle,
  modalSubtitle,
  titleStyle,
  modalContainerStyle,
  urlTittle,
  onClose: optionalOnClose,
}: TModalProps) {
  // useState
  const [searchParams, setSearchParams] = useSearchParams("");
  const [state, setState] = useState(show);

  // useModal
  const { closeModal } = useModal();

  useEffect(() => {
    setState(show);
    //console.log(show);
  }, [show]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);

  // useEffects
  useEffect(() => {
    if (!urlTittle) return;
    let modalState = searchParams.get(urlTittle);
    if (!modalState) {
      setState(false);
    }
  }, [searchParams, urlTittle]);

  // Functions
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      handleClose();
    }
  }, []);

  const handleClose = () => {
    closeModal(`${urlTittle}`)
    setState(false);
  };

  return (
    <StyledWrapper.OuterContainer enabled={state}>
      <StyledWrapper.Overlay
        id={`modal-overlay-${urlTittle}`}
        onClick={() => {
          handleClose();
          optionalOnClose && optionalOnClose();
        }}
      />
      <StyledWrapper.Modal className={modalContainerStyle}>
        <StyledWrapper.ContentContainer>
          <StyledWrapper.Header>
            <div>
              <h6 className={`${titleStyle} subtitle`}>{modalTitle}</h6>
              {modalSubtitle && <i>{modalSubtitle}</i>}
            </div>
            <StyledWrapper.CloseButton
              onClick={() => {
                handleClose();
                optionalOnClose && optionalOnClose();
              }}
            >
              <svg
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.25 17.25L9.75 9.75M17.25 9.75L9.75 17.25"
                  stroke="#BCBCBC"
                />
                <path
                  d="M13.5 26C20.4036 26 26 20.4036 26 13.5C26 6.59644 20.4036 1 13.5 1C6.59644 1 1 6.59644 1 13.5C1 20.4036 6.59644 26 13.5 26Z"
                  stroke="#BCBCBC"
                />
              </svg>
            </StyledWrapper.CloseButton>
          </StyledWrapper.Header>
          {children}
        </StyledWrapper.ContentContainer>
      </StyledWrapper.Modal>
    </StyledWrapper.OuterContainer>
  );
}
